/*eslint-disable */

import QuizGameOptional from '@/components/QuizGameOptional/index';
import QuizGames from '@/components/QuizGames/index';
import QuizzortCategory from '@/components/QuizCategory/index';
import appFooter from '@/components/footer/index';
import { bus } from '@/main';
import quizComputationalS from '@/components/QuizFormatComputationalS/index';
import quizCs from '@/components/QuizFormatCS/index';
import quizFinance from '@/components/QuizFormatFinance/index';
import quizFormat from '@/components/QuizFormat/index';
import quizInstruction from '@/components/QuizInstruction/index';
import quizMachineL from '@/components/QuizFormatMachineL/index';
import welcome from '@/components/welcome-popup/index';

var $ = window.jQuery = require('jquery');
export default {
  name: 'quizzort',
  components: {
    'app-footer': appFooter,
    'welcome-popup': welcome,
    'quiz-format': quizFormat,
    'quiz-instruction': quizInstruction,
    'quiz-category': QuizzortCategory,
    'quiz-cs': quizCs,
    'quiz-finance': quizFinance,
    'quiz-machine': quizMachineL,
    'quiz-computational': quizComputationalS,
    'game-optional': QuizGameOptional,
    'quiz-games': QuizGames
  },
  data() {
    return {
      QuizzortCategory: false,
      QuizInstruction: false,
      QuizGameSpace: false,
      QuizGameCs: false,
      QuizGameFinance: false,
      QuizGameMachineLearing: false,
      QuizGameComputationalS: false,
      QuizzortOptional: false,
      QuizzortGames: false,
      QuizzortPopupEnabled: false
    }
  },
  computed: {},
  mounted() {
    let hash = this.$route.hash;
    if (hash && hash == '#games') {
      setTimeout(() => {
        $(".quizzort_main_wrp").addClass("popup_active");
        $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 100)
      $("body").addClass("quizzort_popup_active");
      this.QuizzortPopupEnabled = true;
      this.QuizzortGames = true;
      window.location.hash = '';
      history.replaceState({}, document.title, ".");
    }
    bus.$on('hideQuizzortPopupEnabled', (data) => {
      this.QuizzortPopupEnabled = data;
    });
    bus.$on('hideQuizCategory', (data) => {
      this.QuizzortCategory = data;
      if (data) {
        $('.quizzort_main_popup_wrp').addClass('category-bg')
      } else {
        $('.quizzort_main_popup_wrp').removeClass('category-bg')
      }
    });
    bus.$on('hideQuizzorOptional', (data) => {
      if (!data) {
        $('.quizzort_main_popup_wrp').addClass('category-bg')
      } else {
        $('.quizzort_main_popup_wrp').removeClass('category-bg')
      }
      this.QuizzortOptional = data;
    });
    bus.$on('showQuizInstruction', (data) => {
      this.QuizInstruction = data;
    });
    bus.$on('showQuizzortGames', (data) => {
      if (data) {
        $('.quizzort_main_popup_wrp').addClass('category-bg')
      } else {
        $('.quizzort_main_popup_wrp').removeClass('category-bg')
      }
      this.QuizzortGames = data;
    });
    bus.$on('showQuizGameSpace', (data) => {
      this.QuizGameSpace = data;
    });
    bus.$on('showQuizGameCS', (data) => {
      this.QuizGameCs = data;
    });
    bus.$on('showQuizGameFinance', (data) => {
      this.QuizGameFinance = data;
    });
    bus.$on('showQuizGameMachineLearning', (data) => {
      this.QuizGameMachineLearing = data;
    });
    bus.$on('showQuizGameComputationalS', (data) => {
      this.QuizGameComputationalS = data;
    });
    $('.app-loader').hide()
  },
  methods: {
    QuizOptionalPopup() {
      setTimeout(() => {
        $(".quizzort_main_wrp").addClass("popup_active");
        $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 100)
      $("body").addClass("quizzort_popup_active");
      this.QuizzortPopupEnabled = true
      this.QuizzortOptional = true
    }
  },
  created(){},
  beforeCreate: function() {
    $('body').addClass('quizzort_wrp');
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('quizzort_wrp');
    next();
  },
}